var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightTagSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.25C3.37665 4.25 1.25 6.37665 1.25 9V15C1.25 17.6234 3.37665 19.75 6 19.75H18C20.6234 19.75 22.75 17.6234 22.75 15V9C22.75 6.37665 20.6234 4.25 18 4.25H6ZM14.5303 15.2803L17.2803 12.5303C17.5732 12.2374 17.5732 11.7626 17.2803 11.4697L14.5303 8.71967C14.2374 8.42678 13.7626 8.42678 13.4697 8.71967C13.1768 9.01256 13.1768 9.48744 13.4697 9.78033L14.9393 11.25H6.75C6.33579 11.25 6 11.5858 6 12C6 12.4142 6.33579 12.75 6.75 12.75H14.9393L13.4697 14.2197C13.1768 14.5126 13.1768 14.9874 13.4697 15.2803C13.7626 15.5732 14.2374 15.5732 14.5303 15.2803Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTagSolid);
export default __webpack_public_path__ + "static/media/arrow-right-tag-solid.43f75a32d49f8913c4ceb869fac89cb8.svg";
export { ForwardRef as ReactComponent };